/**
 * LOCAL STORAGE
 */

/**
 * Store a new settings in the browser
 *
 * @param   {string}    name Name of the setting
 * @param   {string}    val Value of the setting
 *
 * @returns void
 */
window.setStorage = function (name, val) {
    if (typeof Storage !== "undefined") {
        localStorage.setItem(name, val);
    } else {
        window.alert(
            "Please use a modern browser to properly view this template!"
        );
    }
};

/**
 * Get a prestored setting
 *
 * @param   {string}    name Name of the setting
 *
 * @returns {string}    The value of the setting | null
 */
window.getStorage = function (name) {
    if (typeof Storage !== "undefined") {
        return localStorage.getItem(name);
    } else {
        window.alert(
            "Please use a modern browser to properly view this template!"
        );
    }
};
